import { Injectable } from '@angular/core';

import { CanActivate, Router } from '@angular/router';

import { GurdServiceService } from './services/gurd-service.service';

@Injectable({

  providedIn: 'root'

  // 09193023224

})

export class URLGuard implements CanActivate {

  constructor(private _Guard: GurdServiceService, private router: Router) { }

  canActivate(): boolean {

    if (!this._Guard.getToken()) {

      this.router.navigateByUrl("/");

    }

    return true

  }

}
